"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8050],{

/***/ 28050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34892);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(186);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .card-sub-menu {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n\n    .block-1 {\n      width: 150px;\n      display: block;\n      list-style: none;\n      padding: 0 10px 0 0;\n      li {\n        color: var(--softblack-color);\n        padding: 0px 15px !important;\n        border-top-left-radius: 50px;\n        border-bottom-left-radius: 50px;\n        margin-bottom: 10px;\n        margin-right: -10px;\n        i {\n          float: right;\n          color: transparent;\n        }\n        &:hover {\n          background-color: var(--primary-color);\n          color: var(--white-color);\n          i {\n            color: var(--white-color);\n          }\n        }\n      }\n    }\n  }\n  .block-2 {\n    grid-gap: 10px;\n    display: grid;\n    width: 100%;\n    padding: 10px;\n    border-left: var(--border-default);\n    .empty-logo {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-height: 311px;\n      img {\n        opacity: 0.3;\n        max-height: 30px;\n      }\n    }\n    .btn-readmore {\n      text-align: center;\n      margin: 25px auto 10px;\n      a {\n        width: 100%;\n        padding: 5px 80px;\n        background-color: var(--quaternary-color);\n        color: var(--tertiary-color);\n        border-radius: 20px;\n        border: 1px solid var(--quaternary-color);\n\n        &:hover {\n          color: var(--white-color);\n          background-color: var(--primary-color);\n          border: 1px solid var(--primary-color);\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CardH = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 9789).then(__webpack_require__.bind(__webpack_require__, 9789)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9789)
            ];
        }
    }
});
var CardSubMenu = function(param) {
    var data = param.data, eventDataLayer = param.eventDataLayer, heading = param.heading;
    var ref, ref1, ref2;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data[0])) return null;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        key: null,
        data: (ref = data[0]) === null || ref === void 0 ? void 0 : ref.data,
        link: (ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.link,
        name: (ref2 = data[0]) === null || ref2 === void 0 ? void 0 : ref2.nameTh
    }), articles = ref3[0], setArticles = ref3[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WidgetWrapper, {
            className: "card-wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "card-sub-menu",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                        className: "block-1",
                        children: data.map(function(item, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                href: item === null || item === void 0 ? void 0 : item.link,
                                //! DATALAYER
                                onClick: function() {
                                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_6__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, eventDataLayer), {
                                        data: {
                                            title: item === null || item === void 0 ? void 0 : item.nameTh,
                                            heading: "".concat(heading, ":").concat(item === null || item === void 0 ? void 0 : item.nameTh)
                                        }
                                    }));
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                    "aria-hidden": "true",
                                    onMouseOver: function() {
                                        setArticles({
                                            key: index,
                                            data: item === null || item === void 0 ? void 0 : item.data,
                                            link: item === null || item === void 0 ? void 0 : item.link,
                                            name: item === null || item === void 0 ? void 0 : item.nameTh
                                        });
                                    },
                                    onFocus: function() {},
                                    children: item === null || item === void 0 ? void 0 : item.nameTh
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "block-2 card-sub-menu-content",
                        children: [
                            articles === null || articles === void 0 ? void 0 : articles.data.map(function(item, index) {
                                var ref;
                                var ref1;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardH, {
                                    data: item,
                                    shortDate: true,
                                    txtStyle: true,
                                    eyeBall: false,
                                    eventDataLayer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, eventDataLayer), {
                                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.data), {
                                            heading: "".concat(heading !== null && heading !== void 0 ? heading : "", ":").concat((ref1 = item === null || item === void 0 ? void 0 : (ref = item.subCategory) === null || ref === void 0 ? void 0 : ref.th) !== null && ref1 !== void 0 ? ref1 : ""),
                                            title: (item === null || item === void 0 ? void 0 : item.title) || "Default Title" // Provide a default value if `title` is potentially null/undefined
                                        })
                                    })
                                }, index);
                            }),
                            (0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(articles === null || articles === void 0 ? void 0 : articles.data) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "empty-logo",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_5__/* .APP_IMG */ .T, "/new-logo-primary.png"),
                                    alt: "logo",
                                    decoding: "async",
                                    style: {
                                        filter: src_constants__WEBPACK_IMPORTED_MODULE_5__/* .SHOW_RIBBON */ .zC === "true" ? "brightness(0)" : "unset"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "btn-readmore",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    href: articles === null || articles === void 0 ? void 0 : articles.link,
                                    children: "ดูทั้งหมด"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CardSubMenu);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject());


/***/ })

}]);